import React from "react";
import { Gem } from "lucide-react";

/**
 * Premium "Founding Parent" badge — soft matte gold, editorial-clean.
 *
 * Design system (locked to match the reference sample):
 *   • Background : soft warm cream (`#F4E7BE`) — matte, no gradient.
 *   • Keyline    : hair-line 1px `#D9BF7A`.
 *   • Text       : deep amber `#8B5E17`, micro-uppercase, letter-spaced.
 *   • Icon       : small solid `Gem` in the same amber tone (no glow, no shadow).
 *   • Shape      : full pill, subtle only — no drop shadow, no glossy overlay.
 *
 * Kept intentionally quiet so it complements the warm editorial palette rather
 * than shouting like a shiny sticker.
 */
export default function FoundingParentBadge({ size = "xs", compact = false, testid }) {
  const sizing = size === "sm"
    ? "text-[8px] px-1.5 py-[1.5px] gap-[3px]"
    : "text-[8px] px-1.5 py-[1px] gap-[3px]";
  const iconSize = size === "sm" ? 8 : 8;
  return (
    <span
      data-testid={testid || "founding-parent-badge"}
      title="Founding Parent — anggota pendiri komunitas The School Reports"
      className={`inline-flex items-center rounded-full font-semibold uppercase tracking-[0.10em] ${sizing}`}
      style={{
        backgroundColor: "#F4E7BE",
        color: "#8B5E17",
        border: "1px solid #D9BF7A",
      }}
    >
      <Gem size={iconSize} strokeWidth={2.25} />
      {!compact && <span>Founding Parent</span>}
    </span>
  );
}
